import React from 'react';
import CategoryPage from '../components/category/CategoryPage';

function BicharPage({ onOpen }) {
  return <CategoryPage onOpen={onOpen} title="विचार" catSlug="opinion" color="#6B7280" />;
}

export default BicharPage;